import angular from 'angular'
import template from './template.html'

angular.module('nominas.pendientes')
  .component('nominasPendientesLayoutsLayout', {
    template: template,
    controller: NominasPendientesLayoutsLayoutComponent,
    bindings: {
      data: '<',
      onClose: '&',
    },
  });

function NominasPendientesLayoutsLayoutComponent($http, $file, $filter) {
  let $ctrl = this,
    filterBy = $filter('filter'),
    groupBy = $filter('groupBy');

  $ctrl.$onInit = $onInit;
  $ctrl.cerrar = cerrar;
  $ctrl.descargar = descargar;
  $ctrl.error = null;
  $ctrl.fechaPago = undefined;
  $ctrl.file = null;
  $ctrl.filtrar = filtrar;
  $ctrl.filtro = '';
  $ctrl.generar = generar;
  $ctrl.lista = undefined;
  $ctrl.procesando = false;
  $ctrl.resultados = undefined;
  $ctrl.total = 0;
  $ctrl.totalizar = totalizar;

  function $onInit() {
    $ctrl.$promise = $http.get('/api/nominas/layouts/layout', {
        params: {
          id_cuenta: $ctrl.data.id_cuenta,
          interbancario: $ctrl.data.interbancario ? 1 : 0,
        },
        schema: NominasPendientesLayoutsLayoutSchema,
      })
      .then(function (response) {
        $ctrl.lista = $filter('orderBy')(response.data, ['fecha_pago', 'id_nomina', 'colaborador']);
        filtrar();
      });
  }

  function cerrar() {
    $ctrl.onClose();
  }

  function descargar() {
    if (!$ctrl.file)
      return;

    $ctrl.file.save();
  }

  function filtrar() {
    $ctrl.resultados = groupBy(filterBy($ctrl.lista, $ctrl.filtro), 'proyecto');
  }

  function generar() {
    let config = {};

    if ($ctrl.data.id_banco === '007') {
      let consecutivo = parseInt(prompt('Banorte: Especifique el consecutivo de archivo.', 1));

      config.consecutivo = consecutivo > 0 ? consecutivo : 1;
    }

    let data = $ctrl.lista
      .reduce(function (array, nomina) {
        let colaboradores = nomina.colaboradores
          .filter(function (colaborador) {
            return colaborador.$$selected;
          })
          .map(function (item) {
            return item.id_pago;
          })
          .sort();

        return array.concat(colaboradores);
      }, []);

    $ctrl.error = null;
    $ctrl.file = null;
    $ctrl.procesando = true;

    $http.post('/api/nominas/layouts/layout', data, {
        params: {
          id_cuenta: $ctrl.data.id_cuenta,
          interbancario: $ctrl.data.interbancario ? 1 : 0,
          fecha_pago: $ctrl.fechaPago,
          config: config,
        },
        download: true,
      })
      .then(function (response) {
        $ctrl.file = response.data;
        descargar();
      })
      .catch(function (rejection) {
        $ctrl.error = rejection.data;
      })
      .finally(function () {
        $ctrl.procesando = false;
      });
  }

  function totalizar() {
    $ctrl.fechaPago = undefined;

    $ctrl.total = $ctrl.lista.reduce(function (total, nomina) {
      let colaboradores = nomina.colaboradores
        .filter(function (colaborador) {
          return colaborador.$$selected;
        });

      if (!colaboradores.length)
        return total;

      $ctrl.fechaPago = nomina.fecha_pago;

      return total + colaboradores.reduce(function (total, colaborador) {
        return total + colaborador.importe;
      }, 0);
    }, 0);
  }
}

let NominasPendientesLayoutsLayoutSchema = {
  total: 'number',
  colaboradores: {
    importe: 'number',
    indice: 'number',
    layout_generado: 'boolean',
    layout_generado_fecha: 'timestamp',
  },
};



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/layouts/layout/component.js